import {
  IDataExcel,
  IDataPDF,
  IExcelColumn,
} from "@fl/shared/src/types/reports";
import { PageSize, TableCell } from "pdfmake/interfaces";
import StringsFuncs from "../../utils/stringsFuncs";

export interface IGenerateExcelParams {
  title: string;
  sheetName?: string;
  columns: IExcelColumn[];
  rows: any[][];
  orientation?: "landscape" | "portrait";
  margins?: {
    left?: number;
    right?: number;
    top?: number;
    bottom?: number;
    header?: number;
    footer?: number;
  };
  printTitlesRow?: string;
  paperSize?: number;
  fitToHeight?: number;
}

export interface IGeneratePDFParams {
  title: string;
  columns: TableCell[];
  rows: TableCell[][];
  orientation?: "landscape" | "portrait";
  pageSize?: PageSize;
  margins?: [number, number, number, number];
  fontSize?: number;
  headerRows?: number;
  zebraStripe?: boolean;
}

export class ExportDatas {
  static generateExcel({
    title,
    sheetName = "Planilha",
    columns,
    rows,
    orientation = "landscape",
    margins = {},
    printTitlesRow = "1:1",
    paperSize = 9,
    fitToHeight = 100,
  }: IGenerateExcelParams): IDataExcel {
    return {
      headerTitle: title,
      sheetName,
      columns,
      rows,
      pageSetup: {
        fitToPage: true,
        fitToHeight,
        orientation,
        paperSize,
        margins: {
          left: margins.left ?? 0.7,
          right: margins.right ?? 0.7,
          top: margins.top ?? 0.75,
          bottom: margins.bottom ?? 0.75,
          header: margins.header ?? 0.3,
          footer: margins.footer ?? 0.3,
        },
        printArea: new StringsFuncs().dimmensionsArea(
          columns.length,
          rows.length
        ),
        printTitlesRow,
      },
    };
  }

  static col(
    header: string,
    width: number,
    align: "left" | "center" | "right",
    numFmt?: string
  ): IExcelColumn {
    return {
      header,
      font: { bold: true },
      width,
      style: {
        alignment: {
          wrapText: true,
          vertical: "middle",
          horizontal: align,
        },
        ...(numFmt ? { numFmt } : {}),
      },
    };
  }

  static generatePDF({
    title,
    columns,
    rows,
    orientation = "landscape",
    pageSize = "A4",
    margins = [40, 60, 40, 60],
    fontSize = 6,
    headerRows = 1,
    zebraStripe = true,
  }: IGeneratePDFParams): IDataPDF {
    return {
      headerTitle: title,
      pageOrientation: orientation,
      pageSize,
      pageMargins: margins,
      content: {
        style: "table",
        table: {
          dontBreakRows: true,
          headerRows,
          body: [columns, ...rows],
        },
        layout: zebraStripe
          ? {
              fillColor: (rowIndex: number) => {
                return rowIndex % 2 === 1 ? "#fff" : null;
              },
            }
          : undefined,
      },
      styles: {
        table: {
          fontSize,
        },
      },
    };
  }
}
